module.exports = __webpack_public_path__ + "img/card4.4bd0bd0e.png";